import { useSite } from "../lib/site";
import { mediaUrl } from "../lib/api";

const TEAL = "#2F4A4F";
const RED = "#E4472B";

export const LogoMark = ({ className = "h-10 w-12" }) => (
  <svg viewBox="0 0 120 96" className={className} aria-hidden="true" focusable="false">
    <path d="M12 90 L60 18 L108 90" fill="none" stroke={TEAL} strokeWidth="15" strokeLinejoin="miter" strokeMiterlimit="10" />
    <path d="M4 60 L26 84 L54 46" fill="none" stroke={RED} strokeWidth="10" strokeLinejoin="miter" strokeLinecap="square" />
    <path d="M46 44 L58 40 L56 53 Z" fill={RED} />
  </svg>
);

export const LogoFull = ({ className = "" }) => (
  <div className={`flex flex-col items-center text-center ${className}`} dir="ltr">
    <LogoMark className="h-16 w-20" />
    <span className="mt-2 font-[Tajawal] text-xl font-bold leading-tight" style={{ color: TEAL }} lang="ar">لاندمارك فيوتشر</span>
    <span className="font-[Tajawal] text-sm font-medium leading-tight" style={{ color: RED }} lang="ar">للتطوير العقاري</span>
    <span className="mt-1 font-[Manrope] text-lg font-bold leading-tight" style={{ color: TEAL }}>Landmark Future</span>
    <span className="font-[Manrope] text-[9px] font-semibold uppercase tracking-[0.3em]" style={{ color: RED }}>Real Estate Development</span>
  </div>
);

export function Logo({ variant = "icon", className = "" }) {
  const { settings } = useSite();
  if (settings?.logo_url) {
    return <img src={mediaUrl(settings.logo_url)} alt="Landmark Future Real Estate Development" className={className} />;
  }
  if (variant === "full") {
    return (
      <div role="img" aria-label="Landmark Future Real Estate Development" className={`inline-flex rounded-sm bg-ivory px-6 py-5 ${className}`}>
        <LogoFull />
      </div>
    );
  }
  return (
    <span role="img" aria-label="Landmark Future" className={`inline-flex items-center justify-center rounded-sm bg-ivory p-1.5 ${className}`}>
      <LogoMark className="h-7 w-9" />
    </span>
  );
}
